import './RelatedTag.scss';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { Tag } from 'antd';
import { usePeriscopeActions } from '../../hooks';
import React, { useCallback } from 'react';

export interface RelatedTagProps {
	displayName: string;
	sonarObjectId?: number;
	sonarObjectType?: SonarObjectType;
}

export const RelatedTag: React.FC<RelatedTagProps> = ({ displayName, sonarObjectId, sonarObjectType }) => {
	const { openPeriscope } = usePeriscopeActions();
	const hasSonarObjectId = Number.isInteger(sonarObjectId);

	const handleTagClick = useCallback(
		(e: React.MouseEvent<HTMLElement, MouseEvent>) => {
			e.stopPropagation();

			if (hasSonarObjectId && sonarObjectType) {
				openPeriscope({
					id: sonarObjectId as number,
					name: displayName,
					openedFromIndex: -1,
					type: sonarObjectType
				});
			}
		},
		[ displayName, hasSonarObjectId, openPeriscope, sonarObjectId, sonarObjectType ]
	);

	const onClick = hasSonarObjectId ? handleTagClick : undefined;

	return (
		<div className='related-tag salesforce'>
			<Tag onClick={ onClick }>{ displayName }</Tag>
		</div>
	);
};
